var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-icon"},[_c('i',{staticClass:"icon-radio",class:{ checked: _vm.value, disabled: _vm.disabled }})])
}
var staticRenderFns = []

export { render, staticRenderFns }